/* @flow */
import * as Constants from './constants';
import { companyId } from 'modules/profile/getters';
import { List, Map, Record } from 'immutable';

export const makeCompanyWhitelistEndpoint = (store: Object): string =>
  `${Constants.COMPANY_ENDPOINT}/${companyId(store.getState())}/whitelist-terms`;

/* Normalizes whitelist records */
export const normalizeWhitelistEntry = (entry: Object): Map<string, any> => {
  return Record(entry)();
};


// WEBPACK FOOTER //
// ./src/app/modules/company-whitelist/utils.js